import React, { Dispatch, SetStateAction } from 'react';
import { useDispatch } from 'react-redux';
import ConfirmModal from '@components/modal/ConfirmModal';
import { postMarkChallengeAsAssessmentComplete } from '@actions/challenges';
import { Challenge } from 'src/types/shared/Challenge';

const MarkToBeCompletedModal: React.FC<MarkToBeCompletedModalProps> = ({
    challenge,
    setShowMarkToBeCompletedModal,
    groupId,
}) => {
    const dispatch = useDispatch();

    return (
        <ConfirmModal
            title="Ready to be completed"
            description={`Are you sure you want to mark '${challenge.name}' as ready to be completed?`}
            closeModal={() => setShowMarkToBeCompletedModal(false)}
            handleSubmit={() => {
                dispatch(postMarkChallengeAsAssessmentComplete(challenge.id));
                setShowMarkToBeCompletedModal(false);
            }}
        />
    );
};

interface MarkToBeCompletedModalProps {
    challenge: Challenge;
    setShowMarkToBeCompletedModal: Dispatch<SetStateAction<boolean>>;
    groupId: string;
}

export default MarkToBeCompletedModal;
